/** 与 backend/utils/order/orderPaymentStatus.js 口径一致 */

import { ORDER_PAYMENT_STATUS_VALUES } from './orderStatus.js';

const normalizeIsPaid = (isPaid) => {
	if (typeof isPaid === 'boolean') return isPaid;
	if (typeof isPaid === 'string') return isPaid === 'true' || isPaid === 'True' || isPaid === 'TRUE';
	return false;
};

function hasDeliveryReceivable(order) {
	const fromSchedule = order?.scheduleNodes?.some((n) => n.title === '发货/提供服务');
	const fromAR = order?.accountsReceivables?.some((ar) => ar.title === '发货/提供服务' && Number(ar.accountsReceivable) > 0);
	return Boolean(fromSchedule || fromAR);
}

function hasAcceptReceivable(order) {
	const fromSchedule = order?.scheduleNodes?.some((n) => n.title === '验收');
	const fromAR = order?.accountsReceivables?.some((ar) => ar.title === '验收' && Number(ar.accountsReceivable) > 0);
	return Boolean(fromSchedule || fromAR);
}

function hasUnpaidTitleReceivable(order, title) {
	return (order?.accountsReceivables || []).some(
		(ar) => ar?.title === title && Number(ar.accountsReceivable) > 0 && !normalizeIsPaid(ar.isPaid),
	);
}

function hasUnpaidCreditRepayment(order) {
	return (order?.accountsReceivables || []).some(
		(ar) => ar?.title === '额度还款' && Number(ar.accountsReceivable) > 0 && !normalizeIsPaid(ar.isPaid),
	);
}

export function resolveOrderPaymentStatus(order) {
	if (!order) {
		return 'waitingPayPlaceOrder';
	}

	if (hasUnpaidCreditRepayment(order)) {
		return 'waitingPayCredit';
	}

	if (order.isCompleted) {
		return 'payComplete';
	}

	const paymentMethod = order.paymentMethod;
	const isPlaceOrderPaid = Boolean(order.isPlaceOrderPaid);
	const isDeliveryPaid = Boolean(order.isDeliveryPaid);
	const isAcceptPaid = Boolean(order.isAcceptPaid);
	const isDelivered = Boolean(order.isDelivered);
	const isAccepted = Boolean(order.isAccepted);
	const hasDeliveryAR = hasDeliveryReceivable(order);
	const hasAcceptAR = hasAcceptReceivable(order);
	const unpaidDeliveryAR = hasUnpaidTitleReceivable(order, '发货/提供服务');
	const unpaidAcceptAR = hasUnpaidTitleReceivable(order, '验收');

	if (!isPlaceOrderPaid) {
		return 'waitingPayPlaceOrder';
	}

	// 已开应收未付优先（避免 isDeliveryPaid 标志漂移盖住待收验收款）
	if (unpaidDeliveryAR) {
		return 'waitingPayDelivery';
	}
	if (unpaidAcceptAR) {
		return 'waitingPayAccept';
	}

	if (isDelivered && hasDeliveryAR && !isDeliveryPaid) {
		return 'waitingPayDelivery';
	}
	if (isAccepted && hasAcceptAR && !isAcceptPaid) {
		return 'waitingPayAccept';
	}

	if (paymentMethod === '全额支付') {
		return 'payComplete';
	}

	// 与详情一致：无对应计划节点则该段视为已齐；有计划未收齐则不得落到 payComplete
	const deliveryDone = !hasDeliveryAR || isDeliveryPaid;
	const acceptDone = !hasAcceptAR || isAcceptPaid;

	if (deliveryDone && acceptDone) {
		return 'payComplete';
	}
	if (!deliveryDone) {
		return 'waitingPayDelivery';
	}
	if (!acceptDone) {
		return 'waitingPayAccept';
	}

	return 'payComplete';
}

export function normalizeStoredPaymentStatus(paymentStatus, order = null) {
	if (order?.uiHints?.storedPaymentStatus) {
		return order.uiHints.storedPaymentStatus;
	}
	if (!paymentStatus || ORDER_PAYMENT_STATUS_VALUES.includes(paymentStatus)) {
		return paymentStatus;
	}
	if (order) {
		return resolveOrderPaymentStatus(order);
	}
	return paymentStatus;
}
